import * as actionTypes from 'app-redux/actionTypes'

export const setWitholdings = (payload) => {
  return {
    type: actionTypes.SET_WITHOLDINGS,
    payload,
  }
}

export const addWitholdingRedux = (payload) => {
  return {
    type: actionTypes.ADD_WITHOLDING,
    payload,
  }
}

export const editWitholdingRedux = (payload) => {
  return {
    type: actionTypes.EDIT_WITHOLDING,
    payload,
  }
}

export const deleteWitholdingRedux = (payload) => {
  return {
    type: actionTypes.DELETE_WITHOLDING,
    payload,
  }
}
